import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import ReportTabs from "../AllTabs/ReportTabs";

const GstReport = () => {
  const { user, loading: authLoading } = useAuth();
  const [pageLoading, setPageLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [totalGstAmount, setTotalGstAmount] = useState(0);

  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);

  const GetData = async (pageNumber) => {
    setPageLoading(true);
    try {
      const res = await apiService.post(
        `${config.GETGSTREPORT}/${user?.cid}`,
        pageSize,
        pageNumber
      );
      if (res?.succeeded) {
        setLists(res.data);
        const total = res.data.reduce(
          (sum, booking) => sum + (booking.gstAmount || 0),
          0
        );
        setTotalGstAmount(total);
      }
    } catch (error) {
      console.error("Failed to fetch GST report data:", error);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (user && !authLoading) {
      GetData(pageNumber);
    }
  }, [user, authLoading]);

  if (authLoading) return <p>Loading user data...</p>;

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <ReportTabs pageName="GSTREPORT" />
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table
                      className="table align-middle table-striped table-hover"
                      id="gstReportTable"
                    >
                      <thead className="bg-soft-info bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Booking No</th>
                          <th>Booking Type</th>
                          <th>Booking Date</th>
                          <th>Traveler Name</th>
                          <th>Total Price</th>
                          <th>GST Amount</th>
                        </tr>
                      </thead>
                      {pageLoading ? (
                        <tbody>
                          <tr>
                            <td colSpan="7" className="text-center">
                              <img
                                src="/assets/images/loader.webp"
                                width="64px"
                                height="64px"
                                alt="Loading..."
                              />
                              <p>Loading Report, Please wait...</p>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <>
                          <tbody className="list form-check-all">
                            {lists.length > 0 ? (
                              lists.map((item, index) => (
                                <tr key={item.bookingId}>
                                  <td>{index + 1}</td>
                                  <td>{item.bookingNo}</td>
                                  <td>
                                    {item.bookingType === "Flight" ? (
                                      <span className="badge bg-primary-subtle text-primary">
                                        {item.bookingType}
                                      </span>
                                    ) : (
                                      <span className="badge bg-info-subtle text-info">
                                        {item.bookingType}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {moment(item.bookingDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </td>
                                  <td>{item.travellerName}</td>
                                  <td>{item.totalPrice.toFixed(2)}</td>
                                  <td className="fw-bold text-danger">
                                    {item.gstAmount.toFixed(2)}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No records found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td
                                colSpan="6"
                                className="text-end fw-bold fs-14"
                              >
                                Grand Total GST:
                              </td>
                              <td className="fw-bold fs-14 text-danger">
                                {totalGstAmount.toFixed(2)}
                              </td>
                            </tr>
                          </tfoot>
                        </>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GstReport;
